import { useEffect } from 'react';

// A minimal shortcut hook. A future global bus can listen once on document and
// dispatch to subscribers; Phase 0 just wires the per-component handler so the
// API is stable.
export interface ShortcutCombo {
  key: string;
  meta?: boolean;
  ctrl?: boolean;
  shift?: boolean;
  alt?: boolean;
}

export function useShortcut(
  combo: ShortcutCombo,
  handler: (event: KeyboardEvent) => void,
) {
  useEffect(() => {
    const listener = (event: KeyboardEvent) => {
      if (event.key.toLowerCase() !== combo.key.toLowerCase()) return;
      if (!!combo.meta !== event.metaKey) return;
      if (!!combo.ctrl !== event.ctrlKey) return;
      if (!!combo.shift !== event.shiftKey) return;
      if (!!combo.alt !== event.altKey) return;
      handler(event);
    };
    window.addEventListener('keydown', listener);
    return () => window.removeEventListener('keydown', listener);
  }, [combo.key, combo.meta, combo.ctrl, combo.shift, combo.alt, handler]);
}
